<template>
    <div class="payment col-10 offset-1">
        <div v-if="hotelRooms !== undefined && hotelRooms !== null && !hotelRooms.length/* && registerType === 'hotels'*/">
            Brak dostępnych hoteli
        </div>
        <div>
            <div class="row mt-3 text-white" v-for="(form, index) in formFields.fields">
                <div class="col-lg-4 offset-lg-2 col-md-6 col-sm-12">
                    <div class="row align-items-center  text-md-right text-sm-left pb-3">
                        <label class="col-10 mb-0">
                            <h5 class="mb-0" v-html="form.name"></h5>
                        </label>
                        <input type="checkbox" class="form-control col form-check-input-reverse col-1" @change="setPrice" @input="setFormField(form.name, 'does_attend', $event.target.checked)" :disabled="isFieldTrue(form.name, 'with_companion')">
                    </div>
                    <div class="row align-items-center  text-md-right text-sm-left pb-3" id="companion" v-if="isFieldTrue(form.name, 'does_attend') && isFieldTrue(form.name, 'companion_allowed')">
                        <label class="col-10 mb-0"><h5 class=" mb-0">Osoba towarzysząca</h5></label>
                        <input type="checkbox" class="form-control col form-check-input-reverse col-1" @change="setPrice" @input="setFormField(form.name, 'with_companion', $event.target.checked)">
                    </div>
                    <div class="form-row" v-if="isFieldTrue(form.name, 'with_companion')">
                        <input placeholder="Imię i nazwisko" type="text" size="col-md-6" @input="setFormField(form.name, 'companion_name', $event.target.value)">
                    </div>
                    <hr class="my-4" style="background-color: white;" v-if="index != Object.keys(formFields.fields).length - 1">
                </div>
            </div>

            <hr class="my-4" style="background-color: white;">
        </div>
        <div v-if="hotelRooms && ((formFields.fields && formFields.fields.length > 0 && isFieldTrue('Udział stacjonarny', 'does_attend')) || !isOnline)">
            <div class="row mt-3" v-for="eventDate in eventDates">
                <div class="col-lg-4 offset-lg-2 col-md-6 col-sm-12 payment-method-section">
                    <div class="row align-items-center  text-md-right text-sm-left pb-3">
                        <label class="col-10 mb-0">
                            <h4 class="mb-0" v-html="eventDate.date"></h4>
                        </label>
                        <input type="checkbox" class="form-control col form-check-input-reverse col-1" @change="setPrice" :value="eventDate" v-model="eventDate.checked">
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-lg-4 offset-lg-2 col-md-6 col-sm-12">
                    <div class="form-row">
                        <label>Hotel</label>
                        <select @change="setHotelRoom" class='custom-select' v-model='hotelRoom'>
                            <option disabled selected value="">Wybierz rekord</option>
                            <option v-for='hotelRoom in hotelRooms' :value='hotelRoom'>{{ hotelRoom.hotel_name }} - {{ hotelRoom.name }} </option>
                        </select>
                    </div>
                    <div v-if="hotelRoom" >
                        <div v-for="(companion, index) in companions" class="form-row mt-1">
                            <input placeholder="Imię i nazwisko współlokatora" v-model="companion.value" :key="index" type="input" class="form-control">
                        </div>
                    </div>
                </div>
            </div>
<!--            <div class="row mt-3" v-for="(form, index) in formFields.fields">
                <div class="col-lg-4 offset-lg-2 col-md-6 col-sm-12 payment-method-section">
                    <div class="row align-items-center  text-md-right text-sm-left pb-3">
                        <label class="col-10 mb-0">
                            <h4 class="mb-0" v-html="form.name"></h4>
                        </label>
                        <input type="checkbox" class="form-control col form-check-input-reverse col-1" @change="setPrice" @input="setFormField(form.name, 'does_attend', $event.target.checked)" :disabled="isFieldTrue(form.name, 'with_companion')">
                    </div>
                    <div class="row align-items-center  text-md-right text-sm-left pb-3" id="companion" v-if="isFieldTrue(form.name, 'does_attend') && isFieldTrue(form.name, 'companion_allowed')">
                        <label class="col-10 mb-0"><h4 class=" mb-0" v-html="setCompanionLabel(form.name)"></h4></label>
                        <input type="checkbox" class="form-control col form-check-input-reverse col-1" @change="setPrice" @input="setFormField(form.name, 'with_companion', $event.target.checked)">
                    </div>
                    <div class="form-row" v-if="isFieldTrue(form.name, 'with_companion')">
                        <input placeholder="Imię i nazwisko" class="form-control" type="text" size="col-md-6" @input="setFormField(form.name, 'companion_name', $event.target.value)">
                    </div>
                    <hr class="my-4" v-if="index != Object.keys(formFields.fields).length - 1">
                </div>
            </div>-->


        </div>
        <div>

            <hr class="my-4">

            <div class="row mt-3" v-if="this.amount > 0">
                <div class="col-lg-4 offset-lg-2 col-md-6 col-sm-12 payment-method-section">

                    <div class="row align-items-center  text-md-right text-sm-left pb-3 h-50" v-if="this.amount > 0">
                        <label class="col-10 mb-0" for="przelewy24"><img height="40" v-bind:src="(asset_path+'/img/Przelewy24_logo.svg')" /></label>
                        <input type="radio" class="form-control col form-check-input-reverse col-1 h-100" v-model="paymentMethod" value="1" id="przelewy24">
                    </div>

                    <div class="row align-items-center  text-md-right text-sm-left pb-3 h-50" v-if="this.amount > 0">
                        <label class="col-10 mb-0" for="przelew"> <h4 class=" mb-0">Przelew bankowy</h4></label>
                        <input type="radio" class="form-check-input-reverse col-1 h-100" v-model="paymentMethod" value="2" id="przelew">
                    </div>

                </div>

                <div class="col-xl-4 col-lg-5 col-md-6 col-sm-12 coupon-section ">
                    <input placeholder="Mam kod rabatowy" class="mb-2 form-control" v-model="code" v-on:change="setPrice">
                    <h5 class="">Cena: <span v-html="amount"></span>zł brutto</h5>
                    <h5 class="">Rabat: <span v-html="discountValue"></span>zł brutto</h5>
                </div>
            </div>

            <div class="row justify-content-center mt-3" v-if="this.amount > 0">
                <div class="col-md-10 col-sm-12 price-section">
                    <h2 class=" mb-3 mt-5 text-center">Cena finalna: <span v-html="amount"></span>zł brutto</h2>
                    <h6 class=" text-center mb-4">Faktura zostanie wysłana automatycznie po otrzymaniu płatności</h6>
                    <h6 class="text-center mb-4"> Sprawdź aktualność <a v-bind:href="profile_url" target="_blank"> swoich danych </a> przed przejściem do płatności. </h6>
                </div>
            </div>

            <div class="row justify-content-center mt-3">
                <div class="col-sm-12 price-section">
                    <div v-if="agreementInputs.length != 0">
                        <form-agreement-input v-model="agreements" :agreementInputs="agreementInputs" :error-messages="errorMessages"></form-agreement-input>

                        <hr class="my-4">
                    </div>
                </div>

                <div class="price-section">
                    <button v-on:click="handlePaymentForm" :disabled="isDisabled" class=" btn btn-primary btn-lg">
                        <span v-if="this.amount > 0">Przejdź do płatności</span>
                        <span v-else>Zarejestruj się do wydarzenia</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="bank-transfer " v-if="content" v-html="content"></div>
        <notifications group="foo" />
    </div>
</template>
<script>
    import FormInput from "./formInput";
    import FormSelect from './formSelect';
    import FormAgreementInput from "./formAgreementInput";

export default {
    props: ['webinar_id', 'asset_path', 'profile_url', 'is_online'],

    components: {
        FormInput,
        FormSelect,
        FormAgreementInput,
    },

    data() {
        return {
            paymentMethod: null,
            amount: null,
            webinarId: this.webinar_id,
            code: null,
            discountValue: 0,
            content: null,
            agreements: [],
            hotelRooms: [],
            errorMessages: null,
            agreementInputs: [],
            formFields: [],
            customizableFormData: [],
            isDisabled: false,
            hotelRoom: null,
            eventDates: [],
            companions: [],
            isOnline: this.is_online
        }
    },
    beforeMount() {
        this.setPrice();

        axios.get('/api/agreements', {
            params: {
                eventableId: this.webinarId,
                eventableType: 'App\\Models\\Webinar',
            }
        }).then(response => {
            this.agreementInputs = response.data.data;
        });

        axios.get('/api/hotel-rooms', {
            params: {
                eventableId: this.webinarId,
                eventableType: 'App\\Models\\Webinar',
            }
        }).then(response => {
            this.hotelRooms = response.data.data;
        });

        axios.get('/api/eventables/get-dates', {
            params: {
                eventableId: this.webinarId,
                eventableType: 'App\\Models\\Webinar',
            }
        }).then(response => {
            this.eventDates = response.data;
        });

        axios.get('/api/customizable-forms', {
            params: {
                eventableId: this.webinarId,
                eventableType: 'App\\Models\\Webinar',
            }
        }).then(response => {
            this.formFields = response.data.data;
            var newFormData = [];
            this.formFields.fields.forEach(function(item, index) {
                newFormData[index] = {
                    form_name: item.name,
                    with_companion: false,
                    companion_allowed: item.companion_allowed === '1' ? true : false,
                    does_attend: false,
                    companion_name: null
                };
            });

            this.customizableFormData = newFormData;
            console.log(this.customizableFormData);
        });
    },
    methods: {
        setHotelRoom() {
            this.companions = [];
            for(let i = 0; i < this.hotelRoom.person_limit-1; i++) {
                this.companions.push({ value: '' });
            }
            this.setPrice();
        },
        isFieldTrue(formName, inputName) {
            var existIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === formName;
            });

            if(existIndex === -1) {
                return false;
            }

            if(this.customizableFormData[existIndex][inputName] && this.customizableFormData[existIndex][inputName] === true) {
                return true;
            }
            return false;
        },
        isFieldExist(formName) {
            console.log('check');
            var existIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === formName;
            });

            if(existIndex === -1) {
                return false;
            }
            return true;
        },
        setFormField(formName, inputName, value) {
            var existIndex = this.customizableFormData.findIndex(obj => {
                return obj.form_name === formName;
            })

            if(existIndex === -1) {
                var newIndex = this.customizableFormData.length;
                var newArray = {
                    form_name: formName
                };
                newArray[inputName] = value;
                this.$set(this.customizableFormData, newIndex, newArray);
            } else {
                var newArray = this.customizableFormData[existIndex];
                newArray[inputName] = value;
                this.$set(this.customizableFormData, existIndex, newArray);
            }

        },
        setPrice() {
            axios.post('/api/prices', {
                eventableId: this.webinarId,
                eventableType: 'App\\Models\\Webinar',
                customizableFormData: this.customizableFormData,
                eventDates: this.eventDates,
                code: this.code,
                hotelRoom: this.hotelRoom,
            }).then(response => {
                this.amount = response.data.data.price;
                this.discountValue = response.data.data.discountValue;
            }).catch(error => {
                this.discountValue = 0;
                if(error.response.data.errors || error.response.data.message) {
                    this.$notify({
                        'group': 'foo',
                        'type': 'error',
                        'title': error.response.data.message ? error.response.data.message : error.response.data.errors.code[0]
                    });
                }
            });
        },
        handlePaymentForm() {
            this.isDisabled = true;
            console.log('et1');
            if(this.paymentMethod === null && this.amount !== 0) {
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': 'Prosimy wybrać metodę płatności'
                });

                this.isDisabled = false;
                return false;
            }
            console.log('et2');
            if(this.formFields && this.formFields.fields && this.formFields.fields.length > 0 && this.isFieldExist('Udział stacjonarny') && this.isFieldExist('Udział online') && this.isFieldTrue('Udział stacjonarny', 'does_attend') && this.isFieldTrue('Udział online', 'does_attend')) {
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': 'Moźna wybrać tylko jeden rodzaj uczestnictwa'
                });

                this.isDisabled = false;
                return false;
            }
            if(this.formFields && this.formFields.fields && this.formFields.fields.length > 0 && this.isFieldExist('Udział stacjonarny') && this.isFieldExist('Udział online') && !this.isFieldTrue('Udział stacjonarny', 'does_attend') && !this.isFieldTrue('Udział online', 'does_attend')) {
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': 'Prosimy wybrać rodzaj uczestnictwa'
                });

                this.isDisabled = false;
                return false;
            }
            console.log('et3');
            if(this.hotelRoom === null && this.hotelRooms && this.hotelRooms.length > 0 && (!this.isOnline || (this.formFields.fields.length > 0 && this.isFieldTrue('Udział stacjonarny', 'does_attend')))) {
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': 'Prosimy wybrać hotel'
                });

                this.isDisabled = false;
                return false;
            }
            console.log('et4');
            axios.post('/api/payment/create', {
                paymentMethod: this.paymentMethod,
                code: this.code,
                eventableId: this.webinarId,
                eventableType: 'App\\Models\\Webinar',
                amount: this.amount,
                agreements: this.agreements,
                customizableFormData: this.customizableFormData,
                hotelRoom: this.hotelRoom,
                eventDates: this.eventDates,
                companions: this.companions,
            })
                .then(response => {
                    let data = response.data.data;
                    this.errorMessages = '';
                    if(data.redirect_panel) {
                        this.$notify({
                            'group': 'foo',
                            'type': 'success',
                            'title': response.data.message
                        });

                        setTimeout(function () {
                            window.location.href = '/wydarzenie/'+data.id+'/'+data.slug;
                        }, 1500);
                    }
                    if(data.url) {
                        this.$notify({
                            'group': 'foo',
                            'type': 'success',
                            'title': response.data.message
                        });

                        setTimeout(function () {
                            window.location.href = data.url;
                        }, 1500);
                    }
                    if(data.content) {
                        this.$notify({
                            'group': 'foo',
                            'type': 'success',
                            'title': response.data.message
                        });
                        this.content = data.content;
                    }
                })
                .catch(error => {
                    this.isDisabled = false;
                    var errors = error.response.data.errors;
                    Object.values(errors).forEach(singleError => {
                        this.$notify({
                            'group': 'foo',
                            'type': 'error',
                            'title': singleError[0]
                        });
                    });
                });
        },
        setAgreement(e) {
            if(this.agreements.includes(e.target.value)){
                var indexToDrop = this.agreements.indexOf(e.target.value);
                if (indexToDrop !== -1) {
                    this.agreements.splice(indexToDrop, 1);
                }
            } else {
                this.agreements.push(e.target.value);
            }
        },

        getAssetPath(path) {
            return this.asset_path + path;
        },

        setCompanionLabel(formName) {
            return this.webinarId === 341 ? formName === 'Nocleg w pok. 3-os.' ? 'Współlokatorzy' : 'Współlokator' : 'Osoba towarzysząca';
        }
    }
}
</script>


